<template>
  <div>
    <sd-header></sd-header>
    <div class="address-view" style="width: 1200px;margin: auto;">
        <div class="block block1">
            <p class="title">寄送地址</p>
            <table>
                <colgroup style="width: 300px;"></colgroup>
                <colgroup style="width: 200px;"></colgroup>
                <colgroup style="width: 500px;"></colgroup>
                <colgroup style="width: 200px;"></colgroup>
                <thead>
                   <tr>
                       <td>收件人姓名</td>
                       <td>电话号码</td>
                       <td>地址</td>
                       <td>操作</td>
                   </tr>
                </thead>
                <tbody>
                    <tr v-for="item in addressList" @click="selectAddress(item)" :class="{'on':item.id == selectAddressId}">
                        <td>{{item.receiverName}}</td>
                        <td>{{item.userPhone}}</td>
                        <td>{{item.userAdd}}</td>
                        <td>
                            <p class="type to_default"  v-if="item.haveDefault != 2" @click="setDefault(item,1,$event)">设为默认</p>
                            <p class="type default" v-show="item.haveDefault == 2">默认地址</p>
                            <a class="opra" @click="updateAddress(item,$event)">修改</a> |
                            <a class="opra" @click="deleteAddress(item,$event)">删除</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!--<ul>-->
                <!--<li :class="{'on':item.id == selectAddressId}" style="cursor: pointer" v-for="item in addressList" @click="selectAddress(item)">-->
                    <!--<p class="city">{{item.receiverName}}</p>-->
                    <!--<p class="address">-->
                        <!--{{item.userAdd}}-->
                    <!--</p>-->
                    <!--<p class="phone_num">{{item.userPhone}}</p>-->
                    <!--<p class="deal" @click="updateAddress(item,$event)">修改</p>-->
                    <!--<p class="type" v-show="item.haveDefault == 2">默认地址</p>-->
                    <!--<p class="type default" style="color:red;margin-right: 77px" @click="deleteAddress(item,$event)">删除</p>-->
                    <!--<p class="type default" v-if="item.haveDefault != 2" @click="setDefault(item,1,$event)">设为默认</p>-->
                <!--</li>-->
            <!--</ul>-->
            <div class="add" v-show="addressList.length <= 5" @click="addAddress">新增地址<i></i></div>
        </div>
        <!-- 发票 -->
        <div class="block block2">
            <p class="title">发票信息管理</p>
            <ul class="invoice" :class="{'on':item.id == selectInvoiceId}" v-for="item in invoiceList" @click="selectInvoice(item,$event)">
                <li>
                    <ul class="info_ul">
                        <li><span>发票抬头：</span> {{item.invoiceTitle}}</li>
                        <li><span>发票类型：</span> {{options._invoiceType[item.invoiceType]}}</li>
                        <li><span>纳税人识别号：</span> {{item.identifyNumber}}</li>
                        <li><span>注册电话：</span> {{item.regPhone}}</li>
                        <li><span>开户银行：</span> {{item.regBank}}</li>
                        <li><span>银行号码：</span> {{item.bankNumber}}</li>
                        <li><span>注册地址：</span> {{item.regAddress}}</li>
                    </ul>
                </li>
                <li class="invoice-info">
                    <a style="color: #00A0E9;" class="btn mark" @click="updateInvoice(item,$event)">修改</a>
                    <a style="color: red"   class="btn mark" @click="deleteInvoice(item,$event)">删除</a>
                    <a class="btn mark" v-show="item.haveDefault != 2" @click="setDefault(item,2,$event)">设为默认</a>
                    <a class="mark" v-show="item.haveDefault == 2">默认发票</a>
                </li>
            </ul>
            <div class="add" v-show="invoiceList.length <= 5"  @click="addInvoice">新增发票 <i></i></div>
        </div>
        <!-- 其他信息 -->
        <div class="remark">
            <p class="title" style="margin-right: 200px;">项目名称：<span>{{invoiceName}}</span></p>
            <p class="title">发票金额：<span style="color: #FF0415;">￥{{getCustomerAmount}}</span></p>
            <div class="first">
                <p class="title">发票备注：</p>
                <textarea v-model="invoiceRemark"></textarea>
            </div>
            <div class="second">
                <p class="title">其他备注：</p>
                <textarea v-model="otherRemark"></textarea>
            </div>
            <ul class="btn">
                <li @click="submitInvoice(1)">开纸质发票</li>
                <li @click="submitInvoice(2)">开电子发票</li>
            </ul>
        </div>
        <!-- 新增地址 -->
        <add-address ref="addressCtrl" @on-success="getAddressList"></add-address>
        <!-- 新增发票 -->
        <add-invoice ref="invoceCtrl"  @on-success="getInvoiceList"></add-invoice>
    </div>
    <sd-footer></sd-footer>
  </div>
</template>
<script type="es6">
  import { mapState, mapActions , mapGetters} from 'vuex'
  import { util } from '../service/util'
  import addAddress from '../components/addAddress'
  import addInvoice from '../components/addInvoice'
  import sdHeader from '../components/sdHeader'
  import sdFooter from '../components/sdFooter'
  let API = util.api([
      'ADDUSERADDRESS',
      // 用户查询地址
      'GETADDRESSBYUSERID',
      // 用户查询发票信息
      'GETUSERINVOICEBYUSERID',
      // 更新地址
      'UPDATEUSERADDRESS',
      // 更新发票模版
      'UPDATEUSERINVOICE',
      // 提交发票
      'WAITERADDINVOICEAPPLY',
      'DELETEUSERADDRESS',
      'DELETEUSERINVOICEBYID'
    ])
    export default {
      name: 'address-view',
      components: { addAddress,addInvoice,sdHeader,sdFooter },
      data () {
        return {
          oldSearchStr: '',
          // 地址列表
          addressList: [],
          // 发票列表
          invoiceList: [],
          // 选中的地址id
          selectAddressId: '',
          // 选中的模版id
          selectInvoiceId: '',
          // 开票金额
          // customerAmount: 0,
          // 项目名称
          invoiceName: '配音费',
          // 发票备注
          invoiceRemark: '',
          // 其他备注
          otherRemark: ''
        }
      },
      computed: {
        ...mapState({
            userInfo: state => state.common.userInfo,
            options:  state => state.common.options,
            // invoiceOrders: state => state.common.invoiceOrders,
            invoicePays: state => state.common.invoicePays
          }),
        // 获取总金额
        getCustomerAmount() {
            let money = 0;
            this.invoicePays.forEach( d => {
                money += d.realityPay;
            })
            return money;
        },
        getPayIds() {
            let ids = [];
            this.invoicePays.forEach( d => {
                ids.push(d.id);
            })
            return ids;
        },
        // getCustomerAmount() {
        //     let money = 0;
        //     this.invoiceOrders.forEach( d => {
        //         money += d.realityPrice;
        //     })
        //     return money;
        // },
        // getOrderIds() {
        //     let ids = [];
        //     this.invoiceOrders.forEach( d => {
        //         ids.push(d.id);
        //     })
        //     return ids;
        // },

      },
      methods: {
        // 触发更新地址
        updateAddress(item,$e) {
          $e && ($e.cancelBubble = true);
          this.$refs.addressCtrl.doUpdate(item);
        },
        updateInvoice(item,$e) {
          $e && ($e.cancelBubble = true);
          this.$refs.invoceCtrl.doUpdate(item);
        },
        // 触发新增地址
        addAddress() {
          this.$refs.addressCtrl.doAdd();
        },
        addInvoice() {
          this.$refs.invoceCtrl.doAdd();
        },
        // 触发删除
        deleteAddress(item,$e) {
          $e && ($e.cancelBubble = true);
          util.confirm.select('确认操作','确认删除地址？', () => {
            util.kAjax(API.DELETEUSERADDRESS, { id:item.id }, res => {
              this.selectAddressId = '';
              this.getAddressList();
            })
          })
        },
        deleteInvoice(item,$e) { 
          $e && ($e.cancelBubble = true);
          util.confirm.select('确认操作','确认删除发票模版？', () => {
            util.kAjax(API.DELETEUSERINVOICEBYID, { id:item.id }, res => {
              this.selectInvoiceId = '';
              this.getInvoiceList();
            })
          })
        },
        // 设为默认
        setDefault(item, type, $e) {
          // 阻止冒泡
          $e && ($e.cancelBubble = true);
          let param = util.copy(item);
          let api = type == 1 ? API.UPDATEUSERADDRESS : API.UPDATEUSERINVOICE;
          let src = type == 1 ? this.addressList : this.invoiceList;
          param.haveDefault = 2;
          
          util.kAjax(api, param, res => {
            src.forEach( d => {
              d.haveDefault = 1;
            })
            item.haveDefault = 2;
          })
        },
        getAddressList() {
          util.kAjax(API.GETADDRESSBYUSERID,{},res => {
            this.addressList = res.data;
            if(!res.data.length){
              this.addAddress();
            } else {
              this.addressList.forEach( d => {
                  if(d.haveDefault == 2){
                      this.selectAddressId = d.id;
                  }
              })
            }
          })
        },
        getInvoiceList() {
          util.kAjax(API.GETUSERINVOICEBYUSERID,{},res => {
            this.invoiceList = res.data;
            if(!res.data.length){
              this.addInvoice();
            } else {
              this.invoiceList.forEach( d => {
                  if(d.haveDefault == 2){
                      this.selectInvoiceId = d.id;
                  }
              })
            }
          })
        },
        // 选中
        selectAddress(item) {
            this.selectAddressId = item.id;
        },
        selectInvoice(item) {
            this.selectInvoiceId = item.id;
        },
        // 提交发票1.纸质 2.电子
        submitInvoice(type) {
            let param = util.copy({
                // "orderIds": this.getOrderIds,
                "payIds": this.getPayIds,
                "userInvoiceId": this.selectInvoiceId,
                "addressId": this.selectAddressId,
                "customerAmount": this.getCustomerAmount,
                "invoiceRemark": this.invoiceRemark,
                "otherRemark": this.otherRemark,
                "invoiceName": this.invoiceName,
                "invoiceMedium": type,
            })
            // 未选地址或者模版
            if(!param.addressId){
              util.confirm.error('请创建并选择寄送地址！');
              return;
            }
            if(!param.userInvoiceId){
              util.confirm.error('请创建并选择发票模版！');
              return;
            }
            util.kAjax(API.WAITERADDINVOICEAPPLY, param, res => {
                util.confirm.success('申请开票成功！');
                this.$router.push({
                    name: 'OrderView'
                })
            })
        }
      },
      created() {
        if(!this.invoicePays.length){
            this.$router.push({
                name: 'OrderView'
            })
        }
        this.getAddressList();
        this.getInvoiceList();
      },
      destroyed() {
        this.$store.commit('INVOICEORDERS',[]);
      }
    }
</script>

<style>
  .add-btn {
    display: inline-block;
    vertical-align: middle;
    font-weight: 700;
    padding: 0 14px;
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    margin: 0 10px 0 0;
  }

</style>


// WEBPACK FOOTER //
// InvoiceView.vue?475c4435